import React, { createContext, useContext, useState, useEffect } from 'react';
import { ErrorModal } from '../shared/ui/ErrorModal';
import { errorBus } from '../lib/errorBus';

interface ErrorContextType {
  showError: (error: { title?: string; message: string; errorCode?: string }) => void;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [errorDetails, setErrorDetails] = useState<{ title?: string; message: string; errorCode?: string }>({
    message: ''
  });

  const showError = (error: { title?: string; message: string; errorCode?: string }) => {
    setErrorDetails(error);
    setIsOpen(true);
  };

  useEffect(() => {
    const unsubscribe = errorBus.subscribe((error) => {
      showError({
        title: error.title,
        message: error.message,
        errorCode: error.code
      });
    });
    return unsubscribe;
  }, []);

  return (
    <ErrorContext.Provider value={{ showError }}>
      {children}
      <ErrorModal
        isOpen={isOpen}
        title={errorDetails.title}
        message={errorDetails.message}
        errorCode={errorDetails.errorCode}
        onClose={() => setIsOpen(false)}
      />
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};
